import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Collapse, TableCell, TableRow, Icon } from "@material-ui/core";

import Header from "../../../partials/header";
import Loading from "../../loading";
import TableFormat from "../../../partials/TableFormat";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
import EditCard from "./edit";
const headCells = [
  {
    key: "code",
    numeric: false,
    disablePadding: false,
    label: "developer_account_code",
  },
  {
    key: "username",
    numeric: false,
    disablePadding: false,
    label: "developer_account_username",
  },
  {
    key: "tag",
    numeric: false,
    disablePadding: false,
    label: "developer_account_tag",
  },
];

class DeveloperAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: [],
    };
  }
  componentDidMount() {
    this.getListDeveloper();
  }
  getListDeveloper = async (payload) => {
    this.loading.startLoading();
    await this.props.getList(payload);
    this.loading.stopLoading();
  };
  handleOpenCollapes = (id) => {
    const listDeveloper = this.props.listDeveloper;
    const collapse = this.state.collapse;
    for (var i = 0; i <= listDeveloper.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState(collapse);
  };
  handleDelete = async (id) => {
    console.log(id);
    let result = await this.props.deletedeveloperAccount({ ids: id });
    if (result.code === 1) {
      this.getListDeveloper();
      return true;
    }
    return false;
  };
  finishUpdate = (result) => {
    if (result.code === 1) this.handleOpenCollapes(-1);
  };
  renderCollapse = (row, index) => {
    const { classes, listDeveloper } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow key={index} className={classes.tableCellInCollapes}>
        <TableCell
          colSpan={8}
          padding={"none"}
          className={classes.tableCellEdit}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditCard
              data={listDeveloper[index]}
              finishUpdate={this.finishUpdate}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  render() {
    const { t, listDeveloper, total, count } = this.props;
    const { collapse = [] } = this.state;
    return (
      <React.Fragment>
        <Header
          session={t("sidebar_superadmin")}
          title={t("sidebar_develop_account")}
          button={t("sidebar_develop_account_create")}
          actionButton={() =>
            this.props.history.push("/developerAccount/create")
          }
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          title={t("sidebar_develop_account")}
          //   contentDialog={t("do_you_want_to_delete_selected_plugin_category")}
          totalCount={total}
          count={count}
          showFilter={false}
          headCells={headCells}
          size={"medium"}
          collapse={collapse}
          isCollapse={false}
          hiddenSearch={false}
          showCheckBox={true}
          contentDialog={t("do_you_want_delete_campaign")}
          onDelete={this.handleDelete}
          showFilterBranch={false}
          getList={this.getListDeveloper}
          isCollapse={true}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          rows={listDeveloper.map((row, index) => {
            return {
              id: row.code,
              code: row.code,
              username: row.username,
              tag: row.tag,
            };
          })}
        />
      </React.Fragment>
    );
  }
}

DeveloperAccount.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listDeveloper: state.developerAccount.listDeveloper,
  total: state.developerAccount.total,
  count: state.developerAccount.count,
});
const mapDispatch = (dispatch) => ({
  getList: dispatch.developerAccount.getList,
  deletedeveloperAccount: dispatch.developerAccount.deletedeveloperAccount,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(DeveloperAccount)
  )
);
